import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "data-name": "Контур 335986",
      d: "M13.443 19.124a1.751 1.751 0 0 1 0-2.474l3.083-3.082H3.75a1.75 1.75 0 1 1 0-3.5h12.775l-3.083-3.083a1.75 1.75 0 0 1 2.475-2.475l6.07 6.071a1.751 1.751 0 0 1 0 2.474l-6.07 6.07a1.749 1.749 0 0 1-2.475 0Z",
      fill: "#0431a8"
    }, null, -1)
  ]))]))
}
export default { render: render }